exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2T45x{padding:var(--b-space-3xs) var(--b-space-md);background-color:var(--c-brand);color:#fff;font-size:var(--font-size)}._2T45x,._31E_D{text-align:center}._31E_D{font-size:var(--f-text);font-style:italic;padding-bottom:var(--b-space-md)}._2Efdv,._31E_D{color:var(--c-text)}._2Efdv{font-style:normal}", ""]);

// exports
exports.locals = {
	"modalFooter": "_2T45x",
	"modalBody": "_31E_D",
	"modalTitle": "_2Efdv"
};